import { render } from "./Service.vue?vue&type=template&id=583e75ba&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=583e75ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583e75ba"]])

export default __exports__